import layout from '@pc/views/home/components/layout/index.vue'
import G_RULE_DYNAMIC_API from '@pc/api/home/rule_dynamic.js'
const G_PLC_RULE_INDEX_KEY = 'plc_rule_index'
export default {
	data() {
		return {
			navConfig: [{ // 导航配置
				scene: 'solicitOpinions',
				text: '意见征集'
			}, {
				scene: 'publicNotice',
				text: '公示通知'
			}],
			queryParams: { // 查询参数
				limit: 10,
				scene: '',
				page: 1,
				totalNum: 0
			},
			ruleList: [], // 规则列表
			activeIndex: -1, // 当前选中列表序号
			isQuerying: false // 是否查询中
		}
	},
	components: {
		layout
	},
	methods: {
		// 逻辑入口
		init() {
			// 默认查询第一个导航数据
			let index = sessionStorage && sessionStorage.getItem(G_PLC_RULE_INDEX_KEY) || 0
			this.switchNav(+index)
		},

		// 切换导航
		switchNav(index) {
			// 查询中 or 当前导航已选中 禁止切换
			if (this.isQuerying || index === this.activeIndex) {
				return
			}
			// 更新导航选中标志
			this.activeIndex = index
			// 清空列表
			this.ruleList = []
			// 重置列表查询参数
			this.queryParams.scene = this.navConfig[index].scene
			this.queryParams.page = 1
			this.queryParams.totalNum = 0
			// 查询规则列表
			this.queryRuleList()
			// 记录选中的侧边栏
			sessionStorage && sessionStorage.setItem(G_PLC_RULE_INDEX_KEY, index)
		},

		// 查询规则列表
		queryRuleList(page) {
			// 防重
			if (this.isQuerying) {
				return;
			}

			// 默认查询第一页
			if (!page) {
				page = 1
			}

			// 更新查询标志
			this.isQuerying = true;

			G_RULE_DYNAMIC_API.getRuleDynamicsList({
				limit: this.queryParams.limit,
				scene: this.queryParams.scene,
				offset: page // 合同平台offset为页码
			})
				.then(res => {
					this.isQuerying = false;
					if (+res.retcode === 0) {

						let { result_rows: { data, total_num } = {} } = res

						// 更新规则列表
						this.ruleList = data || []
						// 更新分页信息
						this.queryParams.totalNum = total_num
						this.queryParams.page = page;
					}
				})
				.catch(err => {
					this.isQuerying = false;
					this.$message.error(err);
				})
		},

		// 跳转到详情页
		linkToDetail(code) {
			this.$router.push({
				path: '/rule_dynamic_detail',
				query: {
					code,
					scene: this.queryParams.scene
				}
			})
		},

		// 页数切换回调
		currentPageChange(page) {
			this.queryRuleList(page)
		}
	},
	mounted() {
		this.init()
	}
}